import { useNavigate } from 'react-router-dom'
import './Brand.css'
import { ReactComponent as DemexLogo } from '../../assets/svg/demex_wordmark_primary_black_no_bg.svg'

const Brand: React.FC = () => {
  const navigate = useNavigate()
  const onClick = () => {
    navigate('/')
  }
  return (
    <div className="brand-wrapper">
      <DemexLogo className={'brand-logo'} onClick={onClick} />
      <span>Bridge Explorer</span>
    </div>
  )
}

export default Brand
